<template>
  <div class="flex flex-col">
    <h3 class="text-display-small mb-4">{{ feedbackTopic.title }}</h3>
    <div class="mx-auto flex max-w-3xl flex-col gap-4">
      <div class="flex h-52 flex-row gap-4">
        <div class="flex min-w-0 grow flex-col">
          <JournalAnalysisProgress
            :surveys="
              progress.map((p) => ({
                id: p.date,
                date: p.date,
                average: p.average,
                tendency: null,
              }))
            "
            :scale="scale"
            class="h-14"
          />
        </div>
      </div>
      <div v-if="latestValue" class="flex flex-col gap-0.5">
        <div
          class="bg-surface-container rounded-extra-small rounded-t-large flex flex-row items-center justify-between gap-2 px-3 py-3"
        >
          <h3 class="text-title-small">{{ $t('common.last_answers') }}</h3>
          <span class="text-label-large text-on-surface-variant">{{
            useDisplayDate(latestValue.date, { dayName: 'short' })
          }}</span>
        </div>
        <JournalAnalysisMemberItemBody
          :member="member"
          :feedbacks="
            questionsWithFeedbacks.map((question) => ({
              questionId: question.id,
              value: question.value,
              text: question.text,
              id: question.id,
            }))
          "
          :questions="questions"
          class="[&>li]:bg-surface-container [&>li]:rounded-extra-small [&>li:last-child]:rounded-b-large gap-0.5"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import { useDisplayDate } from '../../../core/composables/use-display-date'
  import type { FeedbackTopic } from '../../../core/models/feedback-topic'
  import type { MemberOrUser } from '@/core/models/member/member-or-user'
  import type { Scale } from '../../../core/models/scale'
  import JournalAnalysisProgress from '@/core/components/journal-analysis/JournalAnalysisProgress.vue'
  import JournalAnalysisMemberItemBody from '@/core/components/journal-analysis/JournalAnalysisMemberItemBody.vue'
  interface Props {
    feedbackTopic: FeedbackTopic
    member: MemberOrUser
    latestValue?: {
      date: string
      average: number | null
      feedbacks: ReadonlyArray<{
        questionId: string
        value: number | null
        text: JSON | null
      }>
    }
    progress: ReadonlyArray<{
      date: string
      average: number
    }>
    questions: ReadonlyArray<{
      id: string
      text: string
    }>
    scale: Scale
  }

  const props = defineProps<Props>()

  const questionsWithFeedbacks = computed(() => {
    const result: Array<{
      id: string
      value: number | null
      text: JSON | null
      question: {
        id: string
        text: string
      }
    }> = []
    for (const question of props.questions) {
      const feedback = props.latestValue?.feedbacks.find(
        (feedback) => feedback.questionId == question.id,
      )

      result.push({
        id: question.id,
        value: feedback?.value ?? null,
        text: feedback?.text ?? null,
        question: {
          id: question.id,
          text: question.text,
        },
      })
    }

    return result
  })
</script>
